<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <p>MLRehvid koduleht</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.site-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 96px;
  padding: 24px 20px;
  margin-top: auto;
  background:
    radial-gradient(circle at 50% 0%, rgba(226, 34, 137, 0.16), transparent 34%),
    #151217;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
}

.footer-inner {
  width: min(100%, 1180px);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

p {
  font-style: italic;
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff7fb;
  margin: 0;
}

@media (max-width: 768px) {
  .site-footer {
    min-height: 76px;
    padding: 18px 14px;
  }

  p {
    font-size: 1rem;
  }
}
</style>
